/**
 * Shared customer field validation, mirroring the backend regexes exactly
 * (backend/app/schemas/customer.py, backend/app/services/customer_service.py).
 */

export const MOBILE_REGEX = /^[6-9]\d{9}$/
export const GSTIN_REGEX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/
export const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/
export const PINCODE_REGEX = /^\d{6}$/
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const isValidMobile = (value: string): boolean => MOBILE_REGEX.test(value)
export const isValidGSTIN = (value: string): boolean => GSTIN_REGEX.test(value)
export const isValidPAN = (value: string): boolean => PAN_REGEX.test(value)
export const isValidPincode = (value: string): boolean => PINCODE_REGEX.test(value)
export const isValidEmail = (value: string): boolean => EMAIL_REGEX.test(value)
